import {Variants} from '~/src/types/image';
import {ContentType} from '~/src/utilities/constants/types';

interface TeaserObject {
    title: string;
    titleHeader?: string;
    description: string;
    images?: Variants;
}

interface MetaTeaser {
    web: TeaserObject;
    facebook: TeaserObject;
    twitter: TeaserObject;
}

const buildTeaserContent = (defaultData: any, contentData: any, teaserData: any = null) => {
    const hasTeaser =
        (teaserData?.title && teaserData?.title !== defaultData.title) ||
        (teaserData?.titleHeader && teaserData?.titleHeader !== defaultData.titleHeader) ||
        (teaserData?.lead && teaserData?.lead !== defaultData.lead);
    return {
        titleHeader: teaserData !== null ? undefined : contentData?.titleHeader || defaultData.titleHeader,
        title: hasTeaser ? teaserData?.title : contentData?.title || defaultData.title,
        description: hasTeaser ? teaserData?.lead : contentData?.lead?.text || contentData?.lead || defaultData.lead,
        images: teaserData?.image?.variants || defaultData.image?.variants
    };
};

export const getMetaTeaser = (props: any): MetaTeaser => {
    const feedType = props.type !== ContentType.LIFESTYLE ? props.type : ContentType.ARTICLE;

    const teaserData = props.content.meta.teaser;
    const defaultData = teaserData?.default;
    const facebookData = teaserData?.facebook;
    const twitterData = teaserData?.twitter;
    const contentData = props.content[feedType];

    const teaserObject = {
        web: {
            title: teaserData?.default?.title,
            description: teaserData?.default?.lead
        },
        facebook: {
            title: teaserData?.default?.title,
            description: teaserData?.default?.lead
        },
        twitter: {
            title: teaserData?.default?.title,
            description: teaserData?.default?.lead
        }
    };

    teaserObject.web = buildTeaserContent(defaultData, contentData);
    teaserObject.facebook = buildTeaserContent(defaultData, contentData, facebookData);
    teaserObject.twitter = buildTeaserContent(defaultData, contentData, twitterData);

    return teaserObject;
};
